// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Mobx
import { observer, inject } from "mobx-react";

// MARK: Components
import Table from "../../../../components/Table";
import CircularProgress from "../../../../components/CircularProgress";

// MARK: Stores
import SurveyStore from "../../../../stores/SurveyStore";

// MARK: Resources
import strings from "../../../../resources/strings";

interface IProps {
	surveyStore: SurveyStore;
}

@inject("surveyStore")
@observer
export default class SurveyTable extends React.Component<IProps> {
	public render() {
		const { surveyStore } = this.props;

		return (
			<div className="formsTable">
				<Table
					loading={surveyStore.tableLoading}
					tableIsEmptyMessage={strings.surveys.table.tableIsEmpty}
					prevPage={() => surveyStore.previousPage()}
					nextPage={surveyStore.surveys.length !== 0 ? () => surveyStore.nextPage() : undefined}
					pageOffset={surveyStore.pageOffSet}
					header={surveyStore.tableHeader}
					onClick={surveyStore.openSurveyAnswerDialog}
					rows={surveyStore.tableAnswers}
				/>
			</div>
		);
	}
}
